/**
 * Take a WP route string (with PCRE named capture groups), `such as /author/(?P<id>\d+)`,
 * and generate request handler factory methods for each represented endpoint.
 *
 * @module endpoint-factories
 */
'use strict';

var _defineProperty = require("/home/jenkins/workspace/Production/website-vostro/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var createResourceHandlerSpec = require('./resource-handler-spec').create;

var createEndpointRequest = require('./endpoint-request').create;

var objectReduce = require('./util/object-reduce');
/**
 * Given an array of route definitions and a specific namespace for those routes,
 * recurse through the node tree representing all possible routes within the
 * provided namespace to define path value setters (and corresponding property
 * validators) for all possible variants of each resource's API endpoints.
 *
 * @method generate
 * @param {string} namespace         The namespace string for these routes
 * @param {object} routesByNamespace A dictionary of namespace - route definition
 *                                   object pairs as generated from buildRouteTree,
 *                                   where each route definition object is a dictionary
 *                                   keyed by route definition strings
 * @returns {object} A dictionary of endpoint request handler factories
 */


function generateEndpointFactories(routesByNamespace) {
  return objectReduce(routesByNamespace, function (namespaces, routeDefinitions, namespace) {
    // Create
    namespaces[namespace] = objectReduce(routeDefinitions, function (handlers, routeDef, resource) {
      var handlerSpec = createResourceHandlerSpec(routeDef, resource);
      var EndpointRequest = createEndpointRequest(handlerSpec, resource, namespace); // "handler" object is now fully prepared; create the factory method that
      // will instantiate and return a handler instance

      handlers[resource] = function (options) {
        return new EndpointRequest(_objectSpread(_objectSpread({}, this._options), options));
      }; // Expose the constructor as a property on the factory function, so that
      // auto-generated endpoint request constructors may be further customized
      // when needed


      handlers[resource].Ctor = EndpointRequest;
      return handlers;
    }, {});
    return namespaces;
  }, {});
}

module.exports = {
  generate: generateEndpointFactories
};